export default class ExtendedProperty {
  label = '';
  value = '';

  static create(label: string, value: string): ExtendedProperty {
    const extendedProperty = new ExtendedProperty();
    extendedProperty.label = label;
    extendedProperty.value = value;
    return extendedProperty;
  }
}
